import MsgDispatcher from "./msg-dispatcher"
import { detectOS, getAddrs } from "../../common/common"
import logger from "../../common/logger";
/**
 * 全局数据保存区
 * 注意：数据应该优先放到对应模块中，只有明确放在全局可以简化依赖关系，
 * 有利于降低代码复杂度，才可以放到Store中
 */
class Store {
  constructor() {
    // Protocol handler
    this.msgDispatcher = new MsgDispatcher();
    this.init()
  }
  init () {
    this.websocket = null;
    // 断线恢复标志
    this.restoring = false;

    // 用户信息
    this.userInfo = {
      appId: null,
      groupId: null,
      userId: null,
    };

    // 登录信息
    this.loginParams = {
      accessUrl: "",
      token: null,
      companyId: "",
      forceLogin: 0,    // 0是非强制登录 1是强制登录
      extendInfo: "",
      mutexType: "web",
      registered: 1     // 0是非注册，1是注册
    }

    // 通过呼叫进入分组，退出分组时，需要自动向服务发送呼叫结束消息
    this.callGroupId = null;
    this.callId = null;
    this.ringing = false; // 振铃中
  }
  
  /**
   * 获取ClientID
   */
  getClientId() {
    return "{" + this.userInfo.appId 
      + ";" + this.userInfo.groupId 
      + "};" + this.userInfo.userId;
  }

  /**
   * 构造获取CP的URL参数
   */
  buildGetGateWayParam() {
    return "?appType=24&appId=" + this.userInfo.appId 
      + "&ver=" + SDK_VERSION 
      + "&comid=" + this.loginParams.companyId 
      + "&os=" + detectOS()
      + "&token=" + this.loginParams.token;
  }

  /**
   * 获取信令网关地址
   * @param {*} accessUrl 
   */
  async getSignalGateWay(accessUrl) {
    accessUrl += this.buildGetGateWayParam();
    const gwRes = await fetch(accessUrl, { credentials: 'omit' });
    const gwJson = await gwRes.json();
    if (!gwJson) {
      throw "Invalid response!";
    } else {
      logger.log(JSON.stringify(gwJson));
    }

    // 解析信令网关（只取WebSocket地址）
    const gwAddr = getAddrs('ws', gwJson.result)
    if (!gwAddr) {
      throw "Cannot find websocket gateway!";
    } else {
      logger.log(JSON.stringify(gwAddr));
    }

    return gwAddr;
  }
}

export default new Store();
